var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1.985,
    style: {
      fill: "#C8414B"
    },
    width: 508.03,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.985,
    y: 107.79,
    style: {
      fill: "#FFD250"
    },
    width: 508.03,
    height: 296.42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M223.347,256.409l8.191-33.404c0.754-3.076-1.829-5.994-5.306-5.994h-5.77  c-3.477,0-6.061,2.918-5.306,5.994L223.347,256.409z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.681,
    y: 238.89,
    style: {
      fill: "#F5F5F5"
    },
    width: 19.322,
    height: 74.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.861,
    y: 230.14,
    style: {
      fill: "#FAB446"
    },
    width: 28.984,
    height: 8.756
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 189.531,
    y: 256.41,
    style: {
      fill: "#C8414B"
    },
    width: 48.3,
    height: 8.756
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8414B"
    },
    points: "237.839,291.429 208.856,282.674 208.856,273.919 237.839,282.674  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M78.435,256.409l8.191-33.404c0.754-3.076-1.829-5.994-5.306-5.994h-5.77   c-3.477,0-6.061,2.918-5.306,5.994L78.435,256.409z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M112.248,230.143c-5.335,0-9.661,3.919-9.661,8.756v56.908c0,10.638,10.955,30.643,48.305,30.643  s48.305-20.006,48.305-30.643v-56.908c0-4.835-4.325-8.756-9.661-8.756H112.248L112.248,230.143z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M150.891,273.919h-48.305V239.34c0-5.079,4.118-9.197,9.197-9.197h39.107v43.776H150.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M150.891,273.919h48.305v20.784c0,12.698-10.294,22.992-22.992,22.992h-2.32   c-12.698,0-22.992-10.294-22.992-22.992L150.891,273.919L150.891,273.919z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB446"
    },
    d: "M102.587,273.919h48.305v20.784c0,12.698-10.294,22.992-22.992,22.992h-2.32  c-12.698,0-22.992-10.294-22.992-22.992C102.587,294.703,102.587,273.919,102.587,273.919z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M141.231,313.218v-39.299h-9.661v43.334C135.162,316.592,138.41,315.15,141.231,313.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M121.909,317.253v-43.334h-9.661v39.299C115.069,315.15,118.316,316.592,121.909,317.253z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.241,
    y: 256.41,
    style: {
      fill: "#FFB441"
    },
    width: 28.984,
    height: 8.756
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 112.241,
    y: 238.89,
    style: {
      fill: "#FAB446"
    },
    width: 28.984,
    height: 8.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.081,
    y: 244.1,
    style: {
      fill: "#FAB446"
    },
    width: 19.322,
    height: 15.861
  })), /*#__PURE__*/React.createElement("rect", {
    x: 68.774,
    y: 238.89,
    style: {
      fill: "#F5F5F5"
    },
    width: 19.322,
    height: 74.42
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.941,
    y: 308.94,
    style: {
      fill: "#FAB446"
    },
    width: 28.984,
    height: 8.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.941,
    y: 230.14,
    style: {
      fill: "#FAB446"
    },
    width: 28.984,
    height: 8.756
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.111,
    y: 317.7,
    style: {
      fill: "#5064AA"
    },
    width: 38.643,
    height: 8.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.681,
    y: 308.94,
    style: {
      fill: "#FAB446"
    },
    width: 28.984,
    height: 8.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.031,
    y: 317.7,
    style: {
      fill: "#5064AA"
    },
    width: 38.643,
    height: 8.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.911,
    y: 221.39,
    style: {
      fill: "#FAB446"
    },
    width: 57.967,
    height: 8.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.061,
    y: 195.13,
    style: {
      fill: "#FFB441"
    },
    width: 9.661,
    height: 26.27
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M141.231,208.255c-7.991,0-14.491-5.891-14.491-13.132s6.5-13.132,14.491-13.132   s14.491,5.891,14.491,13.132C155.721,202.364,149.221,208.255,141.231,208.255z M141.231,190.745c-2.665,0-4.83,1.963-4.83,4.378   c0,2.415,2.165,4.378,4.83,4.378c2.665,0,4.83-1.963,4.83-4.378C146.061,192.707,143.896,190.745,141.231,190.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M160.552,208.255c-7.991,0-14.491-5.891-14.491-13.132s6.5-13.132,14.491-13.132   s14.491,5.891,14.491,13.132C175.042,202.364,168.543,208.255,160.552,208.255z M160.552,190.745c-2.665,0-4.83,1.963-4.83,4.378   c0,2.415,2.165,4.378,4.83,4.378c2.665,0,4.83-1.963,4.83-4.378C165.382,192.707,163.217,190.745,160.552,190.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.874,217.011c-7.991,0-14.491-5.891-14.491-13.132s6.5-13.132,14.491-13.132   s14.491,5.891,14.491,13.132S187.864,217.011,179.874,217.011z M179.874,199.5c-2.665,0-4.83,1.963-4.83,4.378   c0,2.415,2.165,4.378,4.83,4.378c2.665,0,4.83-1.963,4.83-4.378C184.704,201.462,182.539,199.5,179.874,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M121.909,217.011c-7.991,0-14.491-5.891-14.491-13.132s6.5-13.132,14.491-13.132   s14.491,5.891,14.491,13.132C136.399,211.12,129.899,217.011,121.909,217.011z M121.909,199.5c-2.665,0-4.83,1.963-4.83,4.378   c0,2.415,2.165,4.378,4.83,4.378s4.83-1.963,4.83-4.378C126.739,201.462,124.574,199.5,121.909,199.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB446"
    },
    d: "M179.874,291.429v4.378c0,2.414-2.167,4.378-4.83,4.378s-4.83-1.964-4.83-4.378v-4.378H179.874   M189.534,282.674h-28.983v13.132c0,7.241,6.501,13.132,14.491,13.132c7.991,0,14.491-5.891,14.491-13.132L189.534,282.674  L189.534,282.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA0D2"
    },
    d: "M175.507,265.163h-0.928c-5.079,0-9.197-4.118-9.197-9.197v-7.872c0-5.079,4.118-9.197,9.197-9.197  h0.928c5.079,0,9.197,4.118,9.197,9.197v7.872C184.704,261.047,180.586,265.163,175.507,265.163z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#5064AA"
    },
    cx: 150.891,
    cy: 273.92,
    rx: 14.491,
    ry: 13.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.061,
    y: 177.61,
    style: {
      fill: "#FAB446"
    },
    width: 9.661,
    height: 26.27
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M121.909,221.388l-9.661-8.756l5.659-5.129c8.748-7.928,20.613-12.381,32.984-12.381l0,0  c12.371,0,24.237,4.454,32.984,12.381l5.659,5.129l-9.661,8.756H121.909z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD250"
    },
    cx: 150.891,
    cy: 212.63,
    rx: 4.83,
    ry: 4.378
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD250"
    },
    cx: 131.571,
    cy: 212.63,
    rx: 4.83,
    ry: 4.378
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD250"
    },
    cx: 170.211,
    cy: 212.63,
    rx: 4.83,
    ry: 4.378
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.941,
    y: 256.41,
    style: {
      fill: "#C8414B"
    },
    width: 48.3,
    height: 8.756
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8414B"
    },
    points: "63.943,291.429 92.926,282.674 92.926,273.919 63.943,282.674  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.5f30750a77f9be43ca71b0173638615a.svg";
export { ForwardRef as ReactComponent };